//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Http from "../../utils/http";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      model: null,
      search: null,
      nextPageUrl: null,
      keyword: "",
      items: [],
      allItems: [],
      http: null,
      lastTypedAt: null
    };
  },
  computed: {
    values: function values() {
      if (this.model) {
        // Depends on whether the field is single or multiple
        return this.$type.isArray(this.model) ? this.model : [this.model];
      } // To avoid empty param error


      return [{
        value: null
      }];
    }
  },
  watch: {
    // From https://codepen.io/pen/?&editable=true&editors=101
    search: function search(val) {
      var _this = this;

      // if (this.http) {
      //   this.http.cancel();
      //   this.http = null;
      // }
      // this.keyword = val;
      if (!val || val.length <= 0) {
        return;
      } // This is not necessary if the server is efficient, but the speed improvement can
      // be noticeable for a server which is slow in handling all the requests (including
      // the canceled ones)


      this.lastTypedAt = Date.now();
      var delay = 500;
      setTimeout(function () {
        var lastTypedDistance = Date.now() - _this.lastTypedAt; // If the user has stopped typing


        if (lastTypedDistance >= delay) {
          if (_this.http) {
            _this.http.cancel();

            _this.http = null;
          }

          _this.keyword = val;

          _this.loadItems(_this.spec.url, false);
        }
      }, delay);
    },
    model: function model(val) {
      this.updateAllItems();
    }
  },
  methods: {
    $ready: function $ready() {
      var selectedItems = this.spec.selectedOptions;
      this.model = this.spec.multiple ? selectedItems : selectedItems[0];
      this.updateAllItems();
      this.loadItems(this.spec.url, false);
    },
    loadMore: function loadMore() {
      if (this.nextPageUrl) {
        this.loadItems(this.nextPageUrl, true);
      }
    },
    loadItems: function loadItems(url, append) {
      var _this2 = this;

      var vm = this;
      this.http = Http.execute({
        url: "".concat(url, "&q=").concat(this.keyword)
      }, "GET", this, function (data, response) {
        _this2.nextPageUrl = data.nextPageUrl;

        var rows = _this2.normalizedRows(data);

        if (append) {
          vm.items = vm.items.concat(rows);
        } else {
          vm.items = rows;
        }

        vm.updateAllItems(); // This causes `Cannot set property 'scrollTop' of undefined` presumably when dropdown is not shown.

        if (append) {
          // Workaround to refresh list after adding new items
          // See https://github.com/vuetifyjs/vuetify/issues/4867
          setTimeout(function () {
            _this2.$refs.autocomplete.onScroll();
          });
        }
      });
    },
    updateAllItems: function updateAllItems() {
      // Make sure selected items/values are in the mix so they can be displayed in the select field.
      this.allItems = this.values.concat(this.items);
    },
    normalizedRows: function normalizedRows(data) {
      return data.rows.map(function (row) {
        var extra = row.extra;
        row.value = extra.value;
        row.text = extra.text;
        return row;
      });
    }
  }
};